import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type { CategoryEntryPointParams, CategoryEntryPointRuntimeProps } from '../../types';
import YourAgentResultsQuery from './__generated__/YourAgentResultsQuery.graphql';
import type { YourAgentResultsQueries } from './types';

type YourAgentResultsEntryPointComponent = EntryPointComponent<
	YourAgentResultsQueries,
	Record<string, never>,
	CategoryEntryPointRuntimeProps,
	Record<string, never>
>;

export const yourAgentResultsEntryPoint: EntryPoint<
	YourAgentResultsEntryPointComponent,
	CategoryEntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<YourAgentResultsEntryPointComponent>(() => import(/* webpackChunkName: "@atlaskit-internal_studio-browse-kit_your-agent-results" */ "./YourAgentResults"), { moduleId: "e3a79903", moduleName: "YourAgentResults", modulePath: "../platform/packages/ai-mate/studio-agent-browse/src/ui/browse-agent/entrypoints/your-agents/YourAgentResults.tsx", priority: "interaction", moduleId: 'studio-browse-kit_your-agent-results' }),
	getPreloadProps: ({ cloudId, product, fetchPolicy = 'store-or-network' }) => ({
		queries: {
			yourAgentResultsQuery: {
				parameters: YourAgentResultsQuery,
				variables: { cloudId, product },
				options: { fetchPolicy },
			},
		},
	}),
});
